<div class="animate-fade-in relative z-10 w-full h-full max-w-6xl mx-auto" (click)="closeMenus()">

  @if (canSeeOtherUsers()) {
  <!-- Header -->
  <div class="mt-header">
    <div class="mt-header__title">
      <svg class="mt-header__icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
      </svg>
      <div class="min-w-0">
        <h1 class="mt-header__headline">My Team</h1>
        <p class="mt-header__sub">Manage your team roster and permissions globally.</p>
      </div>
    </div>
    <div class="flex flex-col-reverse gap-2 sm:flex-row sm:items-center sm:gap-3">
      <button (click)="loadUsers()" class="mt-header__btn">
        <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/></svg>
        Refresh
      </button>
      <button (click)="openInviteModal()" class="mt-header__btn">
        <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" /></svg>
        Invite
      </button>
    </div>
  </div>

  <!-- Stats Grid -->
  <div class="grid grid-cols-2 md:grid-cols-4 gap-3 sm:gap-4 mb-6 sm:mb-8">
    <div class="bg-[var(--bg-panel)] border border-[#ffffff10] rounded-xl p-4 sm:p-5 shadow-sm">
      <div class="text-[var(--text-muted)] text-xs sm:text-sm font-medium mb-1 flex items-center gap-2">
        <div class="w-2 h-2 rounded-full bg-[#506ef7] flex-shrink-0"></div><span class="truncate">Total (filtered)</span>
      </div>
      <div class="text-2xl sm:text-3xl font-bold text-white">{{ totalCount() }}</div>
    </div>
    <div class="bg-[var(--bg-panel)] border border-[#ffffff10] rounded-xl p-4 sm:p-5 shadow-sm">
      <div class="text-[var(--text-muted)] text-xs sm:text-sm font-medium mb-1 flex items-center gap-2">
        <div class="w-2 h-2 rounded-full bg-green-500 flex-shrink-0"></div><span class="truncate">Active (this page)</span>
      </div>
      <div class="text-2xl sm:text-3xl font-bold text-white">{{ activeCount() }}</div>
    </div>
    <div class="bg-[var(--bg-panel)] border border-[#ffffff10] rounded-xl p-4 sm:p-5 shadow-sm">
      <div class="text-[var(--text-muted)] text-xs sm:text-sm font-medium mb-1 flex items-center gap-2">
        <div class="w-2 h-2 rounded-full bg-yellow-400 flex-shrink-0"></div><span>Inactive (this page)</span>
      </div>
      <div class="text-2xl sm:text-3xl font-bold text-white">{{ users().length - activeCount() }}</div>
    </div>
    <div class="bg-[var(--bg-panel)] border border-[#ffffff10] rounded-xl p-4 sm:p-5 shadow-sm">
      <div class="text-[var(--text-muted)] text-xs sm:text-sm font-medium mb-1 flex items-center gap-2">
        <div class="w-2 h-2 rounded-full bg-purple-500 flex-shrink-0"></div><span>Admins (this page)</span>
      </div>
      <div class="text-2xl sm:text-3xl font-bold text-white">{{ adminCount() }}</div>
    </div>
  </div>

  <!-- Error banner -->
  @if (errorMsg()) {
    <div class="mb-6 px-4 py-3 rounded-lg bg-red-500/10 border border-red-500/30 text-red-400 text-sm flex items-center gap-2">
      <svg class="w-4 h-4 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
      {{ errorMsg() }}
    </div>
  }

  <!-- Team Directory -->
  <div class="bg-[var(--bg-panel)] border border-[#ffffff10] rounded-xl shadow-sm team-directory-card">
    <div class="px-4 py-3 sm:px-6 sm:py-4 border-b border-[#ffffff10] space-y-3">
      <div class="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <h2 class="text-base sm:text-lg font-semibold text-white">Directory</h2>
        <div class="mt-filters flex flex-wrap items-center gap-2">
          <div class="relative flex-1 sm:flex-initial min-w-0">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 absolute left-3 top-1/2 -translate-y-1/2 text-[var(--text-muted)] pointer-events-none" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" /></svg>
            <input type="text" placeholder="Search name, email…"
                   [ngModel]="searchQuery()" (ngModelChange)="onSearchInput($event)"
                   class="w-full min-w-0 pl-9 pr-4 py-2 text-sm bg-[#ffffff05] border border-[#ffffff10] rounded-lg text-white focus:outline-none focus:border-[#506ef7] focus:ring-1 focus:ring-[#506ef7] transition-all sm:w-48 placeholder:text-[var(--text-muted)]">
          </div>
          <div class="mt-drop" (click)="$event.stopPropagation()">
            <button type="button" class="mt-select py-2 px-3 text-sm bg-[#ffffff05] border border-[#ffffff10] rounded-lg text-white focus:outline-none focus:border-[#506ef7] cursor-pointer" aria-label="Filter by role" aria-haspopup="listbox" [attr.aria-expanded]="filterMenus.role.open()" (click)="toggleFilterMenu('role')">
              <span>{{ roleFilterLabel() }}</span>
              <svg class="mt-drop__chevron" [class.mt-drop__chevron--open]="filterMenus.role.open() && !filterMenus.role.closing()" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path fill-rule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.17l3.71-3.94a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clip-rule="evenodd"/></svg>
            </button>
            @if (filterMenus.role.open()) {
              <div class="mt-drop__menu" [class.mt-drop__menu--closing]="filterMenus.role.closing()" role="listbox" aria-label="Filter by role">
                @for (opt of roleOptions; track opt.value) {
                  <button type="button" class="mt-drop__option" role="option" [attr.aria-selected]="roleFilter() === opt.value" [class.mt-drop__option--active]="roleFilter() === opt.value" (click)="chooseRoleFilter(opt.value)">{{ opt.label }}</button>
                }
              </div>
            }
          </div>
          <div class="mt-drop" (click)="$event.stopPropagation()">
            <button type="button" class="mt-select py-2 px-3 text-sm bg-[#ffffff05] border border-[#ffffff10] rounded-lg text-white focus:outline-none focus:border-[#506ef7] cursor-pointer" aria-label="Filter by status" aria-haspopup="listbox" [attr.aria-expanded]="filterMenus.status.open()" (click)="toggleFilterMenu('status')">
              <span>{{ statusFilterLabel() }}</span>
              <svg class="mt-drop__chevron" [class.mt-drop__chevron--open]="filterMenus.status.open() && !filterMenus.status.closing()" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path fill-rule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.17l3.71-3.94a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clip-rule="evenodd"/></svg>
            </button>
            @if (filterMenus.status.open()) {
              <div class="mt-drop__menu" [class.mt-drop__menu--closing]="filterMenus.status.closing()" role="listbox" aria-label="Filter by status">
                @for (opt of isActiveOptions; track opt.label) {
                  <button type="button" class="mt-drop__option" role="option" [attr.aria-selected]="isActiveFilter() === opt.value" [class.mt-drop__option--active]="isActiveFilter() === opt.value" (click)="chooseStatusFilter(opt.value)">{{ opt.label }}</button>
                }
              </div>
            }
          </div>
          <div class="mt-drop" (click)="$event.stopPropagation()">
            <button type="button" class="mt-select py-2 px-3 text-sm bg-[#ffffff05] border border-[#ffffff10] rounded-lg text-white focus:outline-none focus:border-[#506ef7] cursor-pointer" aria-label="Sort by" aria-haspopup="listbox" [attr.aria-expanded]="filterMenus.sort.open()" (click)="toggleFilterMenu('sort')">
              <span>{{ sortFilterLabel() }}</span>
              <svg class="mt-drop__chevron" [class.mt-drop__chevron--open]="filterMenus.sort.open() && !filterMenus.sort.closing()" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path fill-rule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.17l3.71-3.94a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clip-rule="evenodd"/></svg>
            </button>
            @if (filterMenus.sort.open()) {
              <div class="mt-drop__menu" [class.mt-drop__menu--closing]="filterMenus.sort.closing()" role="listbox" aria-label="Sort by">
                @for (opt of sortFields; track opt.value) {
                  <button type="button" class="mt-drop__option" role="option" [attr.aria-selected]="sortBy() === opt.value" [class.mt-drop__option--active]="sortBy() === opt.value" (click)="chooseSortFilter(opt.value)">{{ opt.label }}</button>
                }
              </div>
            }
          </div>
          <div class="mt-drop" (click)="$event.stopPropagation()">
            <button type="button" class="mt-select py-2 px-3 text-sm bg-[#ffffff05] border border-[#ffffff10] rounded-lg text-white focus:outline-none focus:border-[#506ef7] cursor-pointer" aria-label="Sort order" aria-haspopup="listbox" [attr.aria-expanded]="filterMenus.order.open()" (click)="toggleFilterMenu('order')">
              <span>{{ orderFilterLabel() }}</span>
              <svg class="mt-drop__chevron" [class.mt-drop__chevron--open]="filterMenus.order.open() && !filterMenus.order.closing()" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path fill-rule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.17l3.71-3.94a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clip-rule="evenodd"/></svg>
            </button>
            @if (filterMenus.order.open()) {
              <div class="mt-drop__menu" [class.mt-drop__menu--closing]="filterMenus.order.closing()" role="listbox" aria-label="Sort order">
                <button type="button" class="mt-drop__option" role="option" [attr.aria-selected]="sortOrder() === 'desc'" [class.mt-drop__option--active]="sortOrder() === 'desc'" (click)="chooseOrderFilter('desc')">Newest first</button>
                <button type="button" class="mt-drop__option" role="option" [attr.aria-selected]="sortOrder() === 'asc'" [class.mt-drop__option--active]="sortOrder() === 'asc'" (click)="chooseOrderFilter('asc')">Oldest first</button>
              </div>
            }
          </div>
        </div>
      </div>
    </div>

    <!-- Loading -->
    @if (isLoading()) {
      <div class="flex items-center justify-center py-16 gap-3 text-[var(--text-muted)]">
        <svg class="animate-spin w-5 h-5" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
        </svg>
        Loading team…
      </div>
    }

    <!-- Empty state -->
    @if (!isLoading() && users().length === 0 && !errorMsg()) {
      <div class="flex flex-col items-center justify-center py-16 text-[var(--text-muted)]">
        <svg class="w-10 h-10 mb-3 opacity-40" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z"/></svg>
        <p class="text-sm">No members found.</p>
      </div>
    }

    <!-- User List -->
    @if (!isLoading()) {
      <div class="divide-y divide-[#ffffff10]">
        @for (user of users(); track user.id; let last = $last) {
          <div class="px-4 py-3 sm:px-6 sm:py-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between hover:bg-[#ffffff03] transition-colors group relative" [class.rounded-b-xl]="last">
            <!-- Avatar + Info -->
            <div class="flex items-center gap-3 sm:gap-4 min-w-0">
              <div class="w-10 h-10 rounded-full flex-shrink-0 flex items-center justify-center font-bold text-white text-sm shadow-sm ring-2 ring-[#ffffff10]"
                   [ngClass]="user.is_active ? 'bg-gradient-to-tr from-purple-500 to-[#506ef7]' : 'bg-[#ffffff15]'">
                @if (user.profile_photo_url) {
                  <img [src]="user.profile_photo_url" class="w-full h-full rounded-full object-cover" [alt]="user.first_name">
                } @else {
                  {{ getInitials(user) }}
                }
              </div>
              <div class="min-w-0 flex-1">
                <div class="text-sm font-medium text-white flex items-center gap-2 flex-wrap">
                  <span class="truncate">{{ user.first_name }} {{ user.last_name }}</span>
                  @for (role of user.roles; track role) {
                    <span [class]="getRoleBadgeClass(role)">{{ getRoleLabel(role) }}</span>
                  }
                  @if (!user.is_active) {
                    <span class="role-badge role-badge--inactive">Inactive</span>
                  }
                </div>
                <div class="text-xs text-[var(--text-muted)] truncate">{{ user.email }}</div>
              </div>
            </div>

            <!-- Actions: always visible on touch (mobile), hover on desktop -->
            <div class="flex items-center justify-end sm:justify-start">
              <div class="relative">
                <button (click)="toggleMenu(user.id, $event)"
                        class="touch-manual-opacity text-[var(--text-muted)] hover:text-white transition-colors p-2.5 sm:p-1.5 hover:bg-[#ffffff10] rounded-lg min-h-[44px] min-w-[44px] sm:min-h-0 sm:min-w-0 flex items-center justify-center"
                        aria-label="Open menu for {{ user.first_name }}">
                  <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 12h.01M12 12h.01M19 12h.01M6 12a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0z"/></svg>
                </button>
                @if (activeMenuId() === user.id) {
                  <div class="dropdown-menu" [class.dropdown-menu--closing]="menuClosing()" [class.dropdown-menu--open-up]="last" (click)="$event.stopPropagation()">
                    @if (!isSuperAdmin(user)) {
                      <button class="dropdown-item" (click)="openRoleModal(user); closeMenus()">
                        <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"/></svg>
                        Edit Roles
                      </button>
                      @if (user.is_active) {
                        <button class="dropdown-item dropdown-item--danger" (click)="openConfirmModal(user, 'deactivate'); closeMenus()">
                          <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"/></svg>
                          Deactivate
                        </button>
                      } @else {
                        <button class="dropdown-item dropdown-item--success" (click)="openConfirmModal(user, 'activate'); closeMenus()">
                          <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
                          Activate
                        </button>
                      }
                    } @else {
                      <div class="dropdown-item opacity-60 cursor-default pointer-events-none">
                        <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"/></svg>
                        Super Admin is protected
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          </div>
        }
      </div>

      <!-- Pagination -->
      @if (!isLoading() && totalPages() > 0) {
        <div class="px-4 py-3 sm:px-6 border-t border-[#ffffff10] flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <div class="text-sm text-[var(--text-muted)]">
            Showing {{ pageRangeStart() }}–{{ pageRangeEnd() }} of {{ total() }}
          </div>
          <div class="flex items-center gap-2 flex-wrap">
            <div class="mt-drop" (click)="$event.stopPropagation()">
              <button type="button" class="mt-select py-1.5 px-2 text-sm bg-[#ffffff05] border border-[#ffffff10] rounded-lg text-white focus:outline-none focus:border-[#506ef7] cursor-pointer" aria-label="Rows per page" aria-haspopup="listbox" [attr.aria-expanded]="filterMenus.pageSize.open()" (click)="toggleFilterMenu('pageSize')">
                <span>{{ pageSizeLabel() }}</span>
                <svg class="mt-drop__chevron" [class.mt-drop__chevron--open]="filterMenus.pageSize.open() && !filterMenus.pageSize.closing()" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path fill-rule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.17l3.71-3.94a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clip-rule="evenodd"/></svg>
              </button>
              @if (filterMenus.pageSize.open()) {
                <div class="mt-drop__menu mt-drop__menu--up" [class.mt-drop__menu--closing]="filterMenus.pageSize.closing()" role="listbox" aria-label="Rows per page">
                  @for (size of [10, 20, 50, 100]; track size) {
                    <button type="button" class="mt-drop__option" role="option" [attr.aria-selected]="pageSize() === size" [class.mt-drop__option--active]="pageSize() === size" (click)="choosePageSize(size)">{{ size }} per page</button>
                  }
                </div>
              }
            </div>
            <div class="flex items-center gap-1">
              <button type="button" (click)="goToPage(page() - 1)" [disabled]="!hasPrev()"
                class="p-2 rounded-lg border border-[#ffffff10] text-[var(--text-muted)] hover:bg-[#ffffff08] hover:text-white disabled:opacity-40 disabled:cursor-not-allowed transition-colors">
                <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/></svg>
              </button>
              <span class="px-3 py-1.5 text-sm text-white">Page {{ page() }} of {{ totalPages() }}</span>
              <button type="button" (click)="goToPage(page() + 1)" [disabled]="!hasNext()"
                class="p-2 rounded-lg border border-[#ffffff10] text-[var(--text-muted)] hover:bg-[#ffffff08] hover:text-white disabled:opacity-40 disabled:cursor-not-allowed transition-colors">
                <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/></svg>
              </button>
            </div>
          </div>
        </div>
      }
    }
  </div>
  } @else {
  <div class="flex flex-col items-center justify-center py-24 px-4">
    <svg class="w-16 h-16 mx-auto text-[var(--text-muted)] opacity-50 mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"/>
    </svg>
    <h2 class="text-xl font-semibold text-white mb-2">Access restricted</h2>
    <p class="text-[var(--text-muted)] text-sm max-w-md">You don't have permission to view other users. Only admins can access the team directory.</p>
  </div>
  }
</div>

<!-- ═══════════════════════════════════════════════════════════════════════════ -->
<!-- INVITE MODAL                                                               -->
<!-- ═══════════════════════════════════════════════════════════════════════════ -->
@if (showInviteModal()) {
  <div class="modal-backdrop" [class.modal-backdrop--closing]="inviteClosing()" (click)="closeInviteModal()">
    <div class="modal-panel" [class.modal-panel--closing]="inviteClosing()" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3 class="modal-title">
          <svg class="w-5 h-5 text-[#506ef7]" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"/></svg>
          Invite Member
        </h3>
        <button class="modal-close-btn" (click)="closeInviteModal()">
          <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/></svg>
        </button>
      </div>

      <form [formGroup]="inviteForm" (ngSubmit)="submitInvite()" class="modal-body">
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div class="form-group">
            <label class="form-label">First Name</label>
            <input formControlName="first_name" type="text" placeholder="John" class="form-input"
                   [class.border-red-500]="inviteForm.get('first_name')?.invalid && inviteForm.get('first_name')?.touched">
            @if (inviteForm.get('first_name')?.invalid && inviteForm.get('first_name')?.touched) {
              <span class="form-error">Required</span>
            }
          </div>
          <div class="form-group">
            <label class="form-label">Last Name</label>
            <input formControlName="last_name" type="text" placeholder="Doe" class="form-input"
                   [class.border-red-500]="inviteForm.get('last_name')?.invalid && inviteForm.get('last_name')?.touched">
            @if (inviteForm.get('last_name')?.invalid && inviteForm.get('last_name')?.touched) {
              <span class="form-error">Required</span>
            }
          </div>
        </div>

        <div class="form-group">
          <label class="form-label">Email Address</label>
          <input formControlName="email" type="email" placeholder="john@example.com" class="form-input"
                 [class.border-red-500]="inviteForm.get('email')?.invalid && inviteForm.get('email')?.touched">
          @if (inviteForm.get('email')?.errors?.['required'] && inviteForm.get('email')?.touched) {
            <span class="form-error">Required</span>
          }
          @if (inviteForm.get('email')?.errors?.['email'] && inviteForm.get('email')?.touched) {
            <span class="form-error">Valid email required</span>
          }
        </div>

        <div class="form-group">
          <label class="form-label">Role</label>
          <select formControlName="role" class="form-input">
            <option value="content_creator">Content Editor</option>
            <option value="admin">Admin</option>
            @if (!hasExistingSuperAdmin()) {
              <option value="super_admin">Super Admin</option>
            }
          </select>
          @if (hasExistingSuperAdmin()) {
            <p class="text-xs text-[var(--text-muted)] mt-1">Only one Super Admin is allowed.</p>
          }
        </div>

        @if (saveError()) {
          <div class="alert-error">{{ saveError() }}</div>
        }
        @if (saveSuccess()) {
          <div class="alert-success">{{ saveSuccess() }}</div>
        }
      </form>

      <div class="modal-footer">
        <button type="button" class="btn-ghost w-full sm:w-auto" (click)="closeInviteModal()">Cancel</button>
        <button type="button" class="btn-primary w-full sm:w-auto justify-center" (click)="submitInvite()" [disabled]="isSaving()">
          @if (isSaving()) {
            <svg class="animate-spin w-4 h-4" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path></svg>
            Sending…
          } @else {
            Send Invite
          }
        </button>
      </div>
    </div>
  </div>
}

<!-- ═══════════════════════════════════════════════════════════════════════════ -->
<!-- EDIT ROLES MODAL                                                           -->
<!-- ═══════════════════════════════════════════════════════════════════════════ -->
@if (showRoleModal()) {
  <div class="modal-backdrop" (click)="closeRoleModal()">
    <div class="modal-panel" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3 class="modal-title">
          <svg class="w-5 h-5 text-[#506ef7] flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"/></svg>
          <span class="truncate">Edit Roles — {{ selectedUser()?.first_name }} {{ selectedUser()?.last_name }}</span>
        </h3>
        <button class="modal-close-btn" (click)="closeRoleModal()">
          <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/></svg>
        </button>
      </div>

      <div class="modal-body">
        <p class="text-sm text-[var(--text-muted)] mb-4">Select one role for this user.</p>
        <div class="form-group">
          <label class="form-label">Role</label>
          <select [ngModel]="editingRole()" (ngModelChange)="setEditingRole($event)" class="form-input w-full py-2.5 px-3 bg-[#ffffff05] border border-[#ffffff10] rounded-lg text-white focus:outline-none focus:border-[#506ef7] cursor-pointer">
            <option value="content_creator">Content Editor</option>
            <option value="admin">Admin</option>
            @if (!hasExistingSuperAdmin()) {
              <option value="super_admin">Super Admin</option>
            }
          </select>
          @if (hasExistingSuperAdmin()) {
            <p class="text-xs text-[var(--text-muted)] mt-1.5">Only one Super Admin is allowed in the system.</p>
          }
        </div>
        @if (saveError()) {
          <div class="alert-error mt-4">{{ saveError() }}</div>
        }
        @if (saveSuccess()) {
          <div class="alert-success mt-4">{{ saveSuccess() }}</div>
        }
      </div>

      <div class="modal-footer">
        <button class="btn-ghost w-full sm:w-auto" (click)="closeRoleModal()">Cancel</button>
        <button class="btn-primary w-full sm:w-auto justify-center" (click)="saveRoles()" [disabled]="isSaving()">
          @if (isSaving()) {
            <svg class="animate-spin w-4 h-4" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path></svg>
            Saving…
          } @else {
            Save Roles
          }
        </button>
      </div>
    </div>
  </div>
}

<!-- ═══════════════════════════════════════════════════════════════════════════ -->
<!-- CONFIRM MODAL                                                              -->
<!-- ═══════════════════════════════════════════════════════════════════════════ -->
@if (showConfirmModal()) {
  <div class="modal-backdrop" (click)="closeConfirmModal()">
    <div class="modal-panel modal-panel--sm" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3 class="modal-title">
          @if (confirmAction() === 'deactivate') {
            <svg class="w-5 h-5 text-red-400" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"/></svg>
            Deactivate User
          } @else {
            <svg class="w-5 h-5 text-green-400" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
            Activate User
          }
        </h3>
        <button class="modal-close-btn" (click)="closeConfirmModal()">
          <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/></svg>
        </button>
      </div>

      <div class="modal-body">
        @if (confirmAction() === 'deactivate') {
          <p class="text-sm text-[var(--text-muted)]">
            Are you sure you want to <span class="text-red-400 font-medium">deactivate</span>
            <strong class="text-white"> {{ selectedUser()?.first_name }} {{ selectedUser()?.last_name }}</strong>?
            They will lose access immediately.
          </p>
        } @else {
          <p class="text-sm text-[var(--text-muted)]">
            Are you sure you want to <span class="text-green-400 font-medium">activate</span>
            <strong class="text-white"> {{ selectedUser()?.first_name }} {{ selectedUser()?.last_name }}</strong>?
            They will regain access immediately.
          </p>
        }
        @if (saveError()) {
          <div class="alert-error mt-4">{{ saveError() }}</div>
        }
      </div>

      <div class="modal-footer">
        <button class="btn-ghost w-full sm:w-auto" (click)="closeConfirmModal()">Cancel</button>
        @if (confirmAction() === 'deactivate') {
          <button class="btn-danger w-full sm:w-auto justify-center" (click)="confirmToggleActivation()" [disabled]="isSaving()">
            @if (isSaving()) { <svg class="animate-spin w-4 h-4" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path></svg> }
            Deactivate
          </button>
        } @else {
          <button class="btn-success w-full sm:w-auto justify-center" (click)="confirmToggleActivation()" [disabled]="isSaving()">
            @if (isSaving()) { <svg class="animate-spin w-4 h-4" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path></svg> }
            Activate
          </button>
        }
      </div>
    </div>
  </div>
}
